const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { each } = require('lodash');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const { MortgageRequestDocumentationCenterItem } = require('./mortgageRequestDocumentationCenterItem');

class MortgageRequestDocumentationCenterLivingPlace extends React.Component {
    constructor(props){
        super(props);

        this.livingPlace = props.livingPlace;
    }

    buildLivingPlaceListItem(idDocumentType, idDocumentNumber) {
        return ( (dataLivingPlaceItem, index) =>
            (<MortgageRequestDocumentationCenterItem
                key={index}
                NSType={index}
                NSVivienda={this.livingPlace.documents.NS_VIVIENDA}
                documentType={dataLivingPlaceItem.documentType}
                documentTypeLabel={dataLivingPlaceItem.documentTypeLabel}
                documentStatus={dataLivingPlaceItem.documentStatus}
                documentEstateId={dataLivingPlaceItem.documentEstateId}
                idDocumentType={idDocumentType}
                idDocumentNumber={idDocumentNumber}
            />)
        );
    }

    render() {
        const livingPlaceListItem = []

        each( this.livingPlace.documents, (obj, idx) =>
            livingPlaceListItem.push(this.buildLivingPlaceListItem(this.livingPlace.idDocumentType, this.livingPlace.idDocumentNumber)(obj, idx))
        );

        return (
            <ContentBox
                title={formatText('mortgageRequestDocumentationCenter-subtitleSectionLivingPlace')}
                smallTitle={true}
                titleSeparator={true}
                customClassName="mortgage-request-documentation-center__section"
            >
                <ul className="list-unstyled mortgage-request-documentation-center__list">
                    {livingPlaceListItem}
                </ul>
            </ContentBox>
        );
    }
}

MortgageRequestDocumentationCenterLivingPlace.propTypes = {
    livingPlace: PropTypes.object,
    idDocumentType: PropTypes.string
}

module.exports = MortgageRequestDocumentationCenterLivingPlace;